// ===== NavbarItem/NavbarItem.styles.js =====
export const navbarItemStyles = (level) => {
  const paddingStart = level * 20 + 16;
  
  return {
    listItemButton: {
      paddingInlineStart: `${paddingStart}px`,
      minHeight: 48,
      '&:hover': {
        backgroundColor: 'action.hover'
      },
      '&.Mui-selected': {
        backgroundColor: 'primary.light',
        '&:hover': {
          backgroundColor: 'primary.main'
        }
      }
    },
    
    listItemIcon: {
      minWidth: 36
    },
    
    typography: {
      fontWeight: level === 0 ? 500 : 400,
      fontSize: Math.max(0.875 - (level * 0.05), 0.75) + 'rem',
      color: level > 2 ? 'text.secondary' : 'text.primary'
    },
    
    expandButton: {
      padding: 0.5
    }
  };
};

// Additional theme-based styles
export const navbarThemeStyles = {
  paper: {
    width: 280,
    height: '100vh',
    //overflow: 'auto',
    borderRight: 1,
    borderColor: 'divider'
  },
  
  container: {
    padding: 1
  }
};
